// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1_kl8","cls2":"Base-cls2_d_f Base-cls1_kl8"};